import React from 'react';

import CreatableSelect from 'react-select/creatable';

export default function CreatableSelectField({ onChange, options, value, className }) {
    const defaultValue = (options, value) => {
        return options ? options.find((option) => option.value == value) : '';
    };
    return (
        <div className={className}>
            <CreatableSelect
                className="react-select-container"
                classNamePrefix="react-select"
                value={defaultValue(options, value)}
                onChange={(value) => onChange(value)}
                options={options}
            />
        </div>
    );
}
